import React from "react";
import Main from "../components/main";
// import UserCheck from "../components/auth";
import Loader from "../components/bootstrap/loader";
import LoginPage from "../components/auth/login-page";
import config from "../config";
import { UserCheck } from "@superloop-bnsc/react-portal";
import {getCurrentUserQuery} from "../components/logic/user";

export default function Index(props) {
  return (<Main>
    <UserCheck Loader={Loader} getCurrentUserQuery={getCurrentUserQuery} portal={config.portal} LoginPage={LoginPage} endpoint={config.authEndpoint} getCurrentUserResult={(result) => result?.data?.classMethods?.User?.getCurrentUser} />
  </Main>);
}

